import { Hero, ServicesGrid, HowItWorks, Stats, VideosSection, ReviewsSection, FAQSection, PageCanvas } from "../components/site/Sections";
import { QuoteForm } from "../components/site/QuoteFormDynamic";
import { SectionHead } from "../components/site/Brand";
import { useContent } from "../context/SiteContext";

export function QuoteSection() {
  const c = useContent("quote_section");
  return (
    <section id="quote" className="relative py-24 px-5 lg:px-8" data-testid="quote-section">
      <SectionHead white={c.title_white} blue={c.title_blue} desc={c.description} stacked />
      <div className="max-w-3xl mx-auto mt-12"><QuoteForm /></div>
    </section>
  );
}

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <PageCanvas>
        <Stats />
        <ServicesGrid />
        <HowItWorks />
        <VideosSection />
        <ReviewsSection />
        <QuoteSection />
        <FAQSection />
      </PageCanvas>
    </div>
  );
}
